import { scaleLinear } from 'd3-scale';
import { isNumber } from './utils';
// Defaults
var DEFAULT_NODE_COLOR = '#999';
var DEFAULT_NODE_SIZE_RANGE = [2, 15];
export function createNodeReducer(_a) {
    var nodeColor = _a.nodeColor, nodeSize = _a.nodeSize, nodeLabel = _a.nodeLabel, _b = _a.scalingFactor, scalingFactor = _b === void 0 ? 1 : _b;
    var nodeSizeScale = null;
    // Creating scales
    if (nodeSize) {
        nodeSizeScale = scaleLinear()
            .domain([nodeSize.min, nodeSize.max])
            .range(DEFAULT_NODE_SIZE_RANGE);
        if (nodeSize.min === nodeSize.max)
            nodeSizeScale = function () { return 3; };
    }
    // Creating actual reducer
    var nodeReducer = function (key, attr) {
        var renderedNode = {
            x: attr.x,
            y: attr.y
        };
        // Color
        if (!nodeColor) {
            renderedNode.color = DEFAULT_NODE_COLOR;
        }
        else {
            if (nodeColor.palette) {
                renderedNode.color =
                    nodeColor.palette[attr[nodeColor.name]] || DEFAULT_NODE_COLOR;
            }
            else {
                renderedNode.color = attr[nodeColor.name] || DEFAULT_NODE_COLOR;
            }
        }
        // Size
        if (!nodeSize) {
            renderedNode.size = DEFAULT_NODE_SIZE_RANGE[0];
        }
        else {
            var v = attr[nodeSize.name];
            v = isNumber(v) ? v : nodeSize.min;
            renderedNode.size = nodeSizeScale(v);
        }
        renderedNode.size *= scalingFactor;
        // Label
        if (!nodeLabel) {
            renderedNode.label = attr.label || key;
        }
        else {
            renderedNode.label = attr[nodeLabel.name] || '<no-label>';
        }
        return renderedNode;
    };
    return nodeReducer;
}
// Defaults
var DEFAULT_EDGE_COLOR = '#ccc';
var DEFAULT_EDGE_SIZE_RANGE = [0.5, 10];
export function createEdgeReducer(_a) {
    var edgeSize = _a.edgeSize, edgeColor = _a.edgeColor, _b = _a.scalingFactor, scalingFactor = _b === void 0 ? 1 : _b;
    var edgeSizeScale = null;
    // Creating scales
    if (edgeSize) {
        edgeSizeScale = scaleLinear()
            .domain([edgeSize.min, edgeSize.max])
            .range(DEFAULT_EDGE_SIZE_RANGE);
    }
    // Creating actual reducer
    var edgeReducer = function (key, attr) {
        var renderedEdge = {};
        // Color
        if (!edgeColor) {
            renderedEdge.color = DEFAULT_EDGE_COLOR;
        }
        else {
            if (edgeColor.palette) {
                renderedEdge.color =
                    edgeColor.palette[attr[edgeColor.name]] || DEFAULT_NODE_COLOR;
            }
            else {
                renderedEdge.color = attr[edgeColor.name] || DEFAULT_NODE_COLOR;
            }
        }
        // Size
        if (!edgeSize) {
            renderedEdge.size = DEFAULT_EDGE_SIZE_RANGE[0];
        }
        else {
            var v = attr[edgeSize.name];
            v = isNumber(v) ? v : edgeSize.min;
            renderedEdge.size = edgeSizeScale(v);
        }
        renderedEdge.size *= scalingFactor;
        return renderedEdge;
    };
    return edgeReducer;
}
